'use strict'

import './autoin.scss'//Extracted by MiniCssExtractPlugin

import * as bootstrap from 'bootstrap';
import './cookie_consent.js';

// 1. Add required class to parenty as most browsers don't support :has() yet
document.querySelectorAll(".form-control[required]").forEach(el => el.parentElement.classList.add('fc-required'));

// 2.Tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new bootstrap.Tooltip(el));

// 3. Popover
//document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => new bootstrap.Popover(el));

// Custom: Add class to nav when "stuck" (assumes scrips are loaded in footer)
const mainnav = document.querySelector('header.sticky-top'), topHeader = document.getElementById('top-header');
if (mainnav !== null && topHeader !== null)
{
    (new IntersectionObserver(
        ([e]) => mainnav.classList.toggle('sticky-is-stuck', e.intersectionRatio < 0.0001),
        {threshold: [0.0001]}
    )).observe(topHeader);
}

// Theme dropdown wiring (theme bootstrap lives in head.phtml as window._SiteTheme)
(() => {
    const ICONS = { auto: 'bi-circle-half', light: 'bi-sun', dark: 'bi-moon-stars' };
    const icon = document.getElementById('theme-icon');
    const setIcon = (mode) => {
        if (!icon) return;
        Object.values(ICONS).forEach(c => icon.classList.remove(c));
        icon.classList.add(ICONS[mode] || ICONS.auto);
    };
    if (window._SiteTheme) setIcon(window._SiteTheme.get());
    document.querySelectorAll('[data-ai-theme]').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            const mode = el.getAttribute('data-ai-theme');
            if (window._SiteTheme) {
                window._SiteTheme.set(mode);
                setIcon(mode);
            }
        });
    });
})();

export { bootstrap };
